import { useEffect, useState } from "react";
import { T } from "./exports";

export const Lbl = ({ch}) => <div style={{fontSize:9,color:T.textSub,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:2}}>{ch}</div>;
export const SH  = ({ch,color=T.blue}) => <div style={{fontSize:9,fontWeight:700,color,textTransform:"uppercase",letterSpacing:"0.1em",padding:"7px 0 3px",borderBottom:`1px solid ${T.border}`,marginBottom:4}}>{ch}</div>;
export const IB  = {background:T.bgInput,border:`1px solid ${T.border}`,borderRadius:3,color:T.text,padding:"3px 5px",fontSize:11,width:"100%",boxSizing:"border-box"};

export function Field({label,value,onChange,type="text",opts,min,max,step=1,placeholder,rows}){
  return(
    <div style={{marginBottom:5}}>
      {label&&<Lbl ch={label}/>}
      {opts
        ?<select value={value??""} onChange={e=>onChange(e.target.value)} style={{...IB,padding:"3px 4px"}}>
            {opts.map(o=>{const v=o?.value??o;const l=o?.label??o;return<option key={v} value={v}>{l}</option>;})}
          </select>
        :type==="color"
          ?<div style={{display:"flex",gap:3,alignItems:"center"}}>
              <input type="color" value={value||"#000000"} onChange={e=>onChange(e.target.value)} style={{width:24,height:22,border:"none",background:"none",cursor:"pointer",padding:0,flexShrink:0}}/>
              <input value={value||""} onChange={e=>onChange(e.target.value)} style={{...IB,flex:1}}/>
            </div>
          :type==="range"
            ?<div style={{display:"flex",gap:4,alignItems:"center"}}>
                <input type="range" min={min} max={max} step={step} value={value} onChange={e=>onChange(Number(e.target.value))} style={{flex:1,accentColor:T.accent}}/>
                <span style={{fontSize:10,color:T.textSub,minWidth:22,textAlign:"right"}}>{value}</span>
              </div>
            :rows
              ?<textarea value={value??""} placeholder={placeholder} rows={rows} onChange={e=>onChange(e.target.value)} style={{...IB,resize:"vertical"}}/>
              :<input type={type} value={value??""} placeholder={placeholder} onChange={e=>onChange(type==="number"?Number(e.target.value):e.target.value)} style={IB}/>
      }
    </div>
  );
}

export function Toggle({label,value,onChange}){
  return(
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:6}}>
      <span style={{fontSize:10,color:T.textSub}}>{label}</span>
      <div onClick={()=>onChange(!value)} style={{width:30,height:16,borderRadius:8,background:value?T.accent:T.bgCard,cursor:"pointer",position:"relative",border:`1px solid ${T.border}`,transition:"background 0.2s"}}>
        <div style={{position:"absolute",top:1,left:value?13:1,width:12,height:12,borderRadius:6,background:"#fff",transition:"left 0.2s"}}/>
      </div>
    </div>
  );
}

export function Clock(){const[t,setT]=useState(new Date());useEffect(()=>{const i=setInterval(()=>setT(new Date()),1000);return()=>clearInterval(i);},[]);return<span>{t.toLocaleTimeString()}</span>;}
